import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

export const SfRenameDialog = ({ item, title, onSave, onClose }) => {
  const [name, setName] = useState("");
  const [shownTitle, setShownTitle] = useState(title);
  useEffect(() => { if (item) { setName(item.nome || ""); setShownTitle(title); } }, [item, title]);
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sf-rename-dialog">
        <DialogHeader><DialogTitle>{shownTitle}</DialogTitle><DialogDescription>Puoi cambiare il nome del file prima di salvarlo.</DialogDescription></DialogHeader>
        <Input autoFocus noUppercase value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && name.trim()) onSave(name.trim()); }} data-testid="sf-rename-input" />
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} data-testid="sf-rename-keep">Mantieni nome</Button>
          <Button onClick={() => name.trim() && onSave(name.trim())} disabled={!name.trim()} data-testid="sf-rename-save" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const SfConfirmDialog = ({ text, onConfirm, onClose }) => (
  <Dialog open={!!text} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-md" data-testid="sf-confirm-dialog">
      <DialogHeader><DialogTitle>Conferma eliminazione</DialogTitle><DialogDescription data-testid="sf-confirm-text">{text}</DialogDescription></DialogHeader>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={onClose} data-testid="sf-confirm-cancel">Annulla</Button>
        <Button onClick={onConfirm} data-testid="sf-confirm-ok" className="bg-red-600 hover:bg-red-700 text-white font-semibold">Elimina</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const SfUploadProgress = ({ items }) => (
  items.length > 0 && (
    <div className="pgp-card p-3 space-y-2" data-testid="sf-upload-progress">
      {items.map((it) => (
        <div key={it.key} data-testid={`sf-upload-item-${it.key}`}>
          <div className="flex justify-between text-xs text-slate-300 mb-1"><span className="truncate pr-2">{it.name}</span>
            <span className={it.status === "error" ? "text-red-500" : "font-mono"}>{it.status === "error" ? it.error : `${it.pct}%`}</span></div>
          <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden">
            <div className={`h-full transition-[width] duration-200 ${it.status === "error" ? "bg-red-500" : "bg-amber-500"}`} style={{ width: `${it.pct}%` }} />
          </div>
        </div>
      ))}
    </div>
  )
);
